import React from 'react'

import { FieldProps as $FieldProps, Field } from 'formik'

import Checkbox, { CheckboxButton } from '../components/Checkbox'
import FieldProps from './FieldProps'
import Error from './FormItemError'

interface CheckBoxProps extends FieldProps {
  defaultChecked?: boolean
  checked?: boolean
  disabled?: boolean
  indeterminate?: boolean
  className?: string
  children?: React.ReactNode
  onChange?: (e: any) => void
  validate?: any
}
export type FormikCheckboxProps = CheckBoxProps

export const FormikCheckboxField: React.FC<FormikCheckboxProps> = ({
  name,
  validate,
  onChange,
  ...restProps
}: FormikCheckboxProps) => (
  <Field name={name} validate={validate}>
    {({ field: { value }, form: { setFieldValue, setFieldTouched }, meta: { error, touched } }: $FieldProps) => (
      <>
        <Checkbox
          name={name}
          checked={value}
          onChange={(event) => {
            setFieldValue(name, event.target.checked)
            setFieldTouched(name, true, false)
            onChange && onChange(event)
          }}
          {...restProps}
        />
        {touched && error && <Error paddingLeft>{error}</Error>}
      </>
    )}
  </Field>
)

const FormikCheckboxFieldButton = ({ name, validate, onChange, ...restProps }: FormikCheckboxProps) => {
  return (
    <Field name={name} validate={validate}>
      {({ field: { value }, form: { setFieldValue, setFieldTouched }, meta: { error, touched } }: $FieldProps) => (
        <>
          <CheckboxButton
            name={name}
            checked={value}
            onChange={(event) => {
              setFieldValue(name, event.target.checked)
              setFieldTouched(name, true, false)
              onChange && onChange(event)
            }}
            {...restProps}
          />
          {touched && error && <Error paddingLeft>{error}</Error>}
        </>
      )}
    </Field>
  )
}

export { FormikCheckboxField as Checkbox, FormikCheckboxFieldButton as FormikCheckBoxButton }
export default FormikCheckboxField
